module.exports = __webpack_public_path__ + "static/media/Social_elTwitter_circle_565811.e78693e7.png";